import { IPerson } from "../../../data/Person"
import type { AdminRootState } from '../AdminStore'
import { createPersonSliceHelper, IPersonsState } from './PersonSliceHelpers'
import { getDoctorsAsync } from './PersonThunks'

const initialState: IPersonsState = {
  all: new Array<IPerson>(),
  status: 'idle'
}

export const personsSlice = createPersonSliceHelper('doctor', initialState, getDoctorsAsync)

export const { add, update } = personsSlice.actions

export const selectAll = (state: AdminRootState) => state.doctors.all
export const selectStatus = (state:  AdminRootState) => state.doctors.status
export default personsSlice.reducer

